import React, { useState, useEffect } from 'react';
import { getMotoboys, addMotoboy, deleteMotoboy } from '../services/apiServices';
import styles from './RegisterSaleModal.module.css'; // Reutilizando estilos

const ManageMotoboysModal = ({ isOpen, onClose }) => {
  const [motoboys, setMotoboys] = useState([]);
  const [newMotoboyName, setNewMotoboyName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchMotoboys = async () => {
    setLoading(true);
    try {
      const data = await getMotoboys();
      setMotoboys(data);
    } catch (err) {
      setError('Falha ao carregar motoboys.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchMotoboys();
    }
  }, [isOpen]);

  const handleAdd = async () => {
    if (!newMotoboyName.trim()) return;
    try {
      await addMotoboy(newMotoboyName);
      setNewMotoboyName('');
      fetchMotoboys(); // Recarrega a lista
    } catch (err) {
      setError('Falha ao adicionar motoboy.');
    }
  };

  const handleDelete = async (motoboyId) => {
    if (window.confirm('Tem certeza que deseja remover este motoboy?')) {
      try {
        await deleteMotoboy(motoboyId);
        fetchMotoboys(); // Recarrega a lista
      } catch (err) {
        setError('Falha ao remover motoboy.');
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>Gerenciar Motoboys</h2>
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.addItemForm}>
          <input
            type="text"
            value={newMotoboyName}
            onChange={(e) => setNewMotoboyName(e.target.value)}
            placeholder="Nome do novo motoboy"
          />
          <button onClick={handleAdd}>Adicionar</button>
        </div>
        {loading ? <p>Carregando...</p> : (
          <ul className={styles.cartList}>
            {motoboys.map(mb => (
              <li key={mb.id}>
                {mb.name}
                <button type="button" onClick={() => handleDelete(mb.id)}>&times;</button>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.modalActions}>
          <button onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
};

export default ManageMotoboysModal;